var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMoneyBag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.333 16.333h-7V14a7 7 0 0 0-7-7h-4.667a7 7 0 0 0-7 7v2.333h-7a7 7 0 0 0-7 7V42a7 7 0 0 0 7 7h32.667a7 7 0 0 0 7-7V23.333a7 7 0 0 0-7-7Zm-21-2.333a2.333 2.333 0 0 1 2.333-2.333h4.667A2.333 2.333 0 0 1 32.666 14v2.333h-9.333V14Zm-14 9.333A2.333 2.333 0 0 1 11.666 21h2.333a4.666 4.666 0 0 1-4.666 4.667v-2.334Zm2.333 21A2.333 2.333 0 0 1 9.333 42v-2.333a4.666 4.666 0 0 1 4.666 4.666h-2.333Zm35-2.333a2.333 2.333 0 0 1-2.333 2.333h-2.334a4.667 4.667 0 0 1 4.667-4.666V42Zm0-7a9.333 9.333 0 0 0-9.333 9.333H18.666A9.333 9.333 0 0 0 9.333 35v-4.667A9.333 9.333 0 0 0 18.666 21h18.667a9.333 9.333 0 0 0 9.333 9.333V35Zm0-9.333A4.667 4.667 0 0 1 41.999 21h2.334a2.333 2.333 0 0 1 2.333 2.333v2.334Zm-18.667 0a7 7 0 1 0 0 13.999 7 7 0 0 0 0-14ZM28 35a2.333 2.333 0 1 1 0-4.667A2.333 2.333 0 0 1 28 35Z",
    fill: "#F2F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMoneyBag);
export default __webpack_public_path__ + "static/media/icon-money-bag.3bbd332b059a366ffa0b0e66167e5011.svg";
export { ForwardRef as ReactComponent };